import type { CardProps } from '@leafwell/components';
import type { RelatedStrains } from 'types/strains';

import { Card, Paragraph } from '@leafwell/components';
import Figure from './figure';
import StrainTypes from './strain-types';
import { useEventsTracker } from 'contexts/eventsTracker';

const StrainCardRest: React.FC<
  RelatedStrains &
    Partial<
      Pick<CardProps, 'variant'> & {
        className?: string;
      }
    >
> = ({
  cannabinoids,
  thc,
  featuredMedia,
  title,
  strainType,
  variant = 'white',
  uri,
  className,
}) => {
  const isWhite = variant === 'white';
  const { trackEvent } = useEventsTracker();

  return (
    <Card
      {...{
        className: ['relative group', className].join(' '),
        filled: true,
        href: uri,
        rounded: true,
        tagName: 'a',
        variant,
      }}
      onClick={() =>
        trackEvent({
          event: 'select_content',
          content_type: title,
          item_id: 'strains',
          origin: 'block_strains_card',
        })
      }
    >
      <div
        {...{
          className: [
            'absolute w-full h-full bg-inherit transition duration-300 rounded-[inherit] group-hover:scale-105',
            isWhite ? 'group-hover:shadow-lg' : '',
          ].join(' '),
        }}
      ></div>
      <StrainTypes nodes={strainType} variant={isWhite ? 'default' : 'white'} />
      {featuredMedia && (
        <Figure
          {...{ ...featuredMedia }}
          className="w-20 h-20 md:w-32 md:h-32 mx-auto"
          classNameImage="mix-blend-multiply"
          objectFit="contain"
        />
      )}
      <div className="relative self-end">
        <Paragraph
          {...{
            className: 'font-medium',
            size: 'large',
          }}
        >
          {title}
        </Paragraph>
        <Paragraph
          {...{
            size: 'small',
          }}
        >
          <span>
            THC {thc.quantityStart}%
            {thc?.quantityEnd &&
              thc?.quantityEnd !== thc.quantityStart &&
              `-${thc.quantityEnd}%`}
          </span>
          {cannabinoids?.[0] && (
            <span className="pl-2">
              {cannabinoids[0].abbreviation} {cannabinoids[0].quantityStart}%
              {cannabinoids[0]?.quantityEnd &&
                cannabinoids[0]?.quantityEnd !==
                  cannabinoids[0]?.quantityStart &&
                `-${cannabinoids[0].quantityEnd}%`}
            </span>
          )}
        </Paragraph>
      </div>
    </Card>
  );
};

export default StrainCardRest;
